const rupaMigration = {
  productTour: "Product Tour",
  onboarding: {
    banner: {
      title: "Required action",

      body: "You must sign the Labs Terms of Service and Business agreement before you can place an order on Fullscript.",
      cta: "Sign required documents",
    },
    customFeeBanner: {
      title: "Custom fee not setup for Fullscript",
      body: "You must go through a quick set up process to begin adding custom fees on Fullscript. You will only need to do this once.",
      cta: "Set up custom fee",
    },
    allRupaSetupTasksCompleted: "All Rupa setup tasks completed",
    confirmAccountDetails: {
      title: "Review your details",
      clinicName: "clinic name",
      address: "address",
      phoneNumber: "phone number",
      description:
        "Your current {{dataType}} on Fullscript is {{-fullscriptData}}. On Rupa, you used {{-rupaData}}.",
      suggestion: "Would you like to change your {{dataType}} to the one you used on Rupa?",
      no: "No, keep using {{-fullscriptData}}",
      yes: "Change to {{-rupaData}}",
      updatedSuccessfully: "Successfully updated {{dataType}}",
      noMoreDifferencesToReview: "No more differences to review",
    },
  },
  accountSetupProgressMenu: {
    completeRupaMove: "Complete Rupa move",
    stepsCompleted: "{{count}} of {{total}} steps completed",
    signRequiredDocuments: {
      title: "Sign documents (required)",
      body: "You must sign the Labs Terms of Service and Business agreement before you can place an order on Fullscript.",
      actionButtonText: "Sign documents",
    },
    setCustomFees: {
      title: "Set up custom fees",
      body: "Add your bank details to receive payouts for custom fees on your lab test orders. These fees are available to add on a <strong>per-test</strong> basis, unlike the <strong>per-order</strong> setting on Rupa.",
      actionButtonText: "Set up custom fees",
      modal: {
        title: "Skip setting up custom fees?",
        primaryButton: "Don't want custom fees",
        content:
          "You will need to complete this step before you can charge custom fees on any new orders.",
      },
    },
    confirmAccountDetails: {
      title: "Confirm your account details",
      body1:
        "There were some inconsistencies between your Rupa Health account details and Fullscript details.",
      body2: "Please review to make sure everything is the way you want it!",
      actionButtonText: "Review",
      modal: {
        title: "Skip account details review?",
        primaryButton: "Don't want to review",
        content:
          "You can change your account details later in <dispensaryLink>Dispensary settings</dispensaryLink>.",
      },
    },
  },
};
export { rupaMigration };
